<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">장바구니</h1>
      <BreadCrumb :breadcrumbs="initData.page.breadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 장바구니 페이지 -->
      <div class="p-basket-wrap">
        <div
          v-if="
            initData.list.orderableBasketListCount > 0 ||
            initData.list.soldOutBasketListCount > 0
          "
          class="l-white-box"
        >
          <section
            class="basket-list-box"
            v-if="initData.list.orderableBasketListCount > 0"
          >
            <div class="line-title-box c-title-level3">
              <strong>주문가능제품 : </strong>
              <b>{{ initData.list.orderableBasketListCount }}개</b>
            </div>
            <div class="c-order-control-box">
              <div class="left-box">
                <div class="c-checkbox type-small">
                  <input
                    type="checkbox"
                    id="all-basket-chk1"
                    name="basket-group1"
                    v-model="allChecked"
                  />
                  <label for="all-basket-chk1">전체선택</label>
                </div>
                <button
                  type="button"
                  class="btn-selected-delete"
                  @click="deleteCheckedItems()"
                >
                  <i class="c-icon icon-check"></i>
                  <span>선택삭제</span>
                </button>
              </div>
              <!-- D: PC 전용 -->
              <div class="right-box only-pc">
                <button
                  type="button"
                  class="c-util-button type-line-black"
                  @click="orderNow(null, 'checked')"
                >
                  <span>선택제품 주문하기</span>
                </button>
                <button
                  type="button"
                  class="c-util-button type-primary"
                  @click="orderNow(null, 'all')"
                >
                  <span>전체제품 주문하기</span>
                </button>
              </div>
              <!-- // D: PC 전용 -->
            </div>
            <!-- D: PC 전용 -->
            <div class="scroll-x">
              <div class="scroll-x-inner">
                <div class="table-box only-pc" style="width: 1102px">
                  <div class="c-table">
                    <table>
                      <caption>
                        장바구니 주문가능제품 리스트 테이블
                      </caption>
                      <colgroup>
                        <col style="width: 500px" />
                        <col style="width: 120px" />
                        <col />
                        <col />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">제품</th>
                          <th scope="col">용량</th>
                          <th scope="col">수량</th>
                          <th scope="col">금액</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="checkedItems.length > 0">
                          <BasketOrderableRow
                            v-for="(item, index) in initData.list
                              .orderableBasketList"
                            :key="item.cartSn"
                            :index="index"
                            :item="item"
                            :checked="checkedItems[index]?.checked"
                            @checked="(checked) => handleCheck(index, checked)"
                            @detail="(item) => openProdInfoPop(item)"
                            @ordertemp="(item) => orderNow(item, 'alone')"
                          />
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-order-control-box flex-ar only-pc">
              <div class="right-box">
                <button
                  type="button"
                  class="c-util-button type-line-black"
                  @click="orderNow(null, 'checked')"
                >
                  <span>선택제품 주문하기</span>
                </button>
                <button
                  type="button"
                  class="c-util-button type-primary"
                  @click="orderNow(null, 'all')"
                >
                  <span>전체제품 주문하기</span>
                </button>
              </div>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-products only-mo">
              <template v-if="checkedItems.length > 0">
                <MoBasketOrderableRow
                  v-for="(item, index) in initData.list.orderableBasketList"
                  :key="item.cartSn"
                  :index="index"
                  :item="item"
                  :checked="checkedItems[index]?.checked"
                  @checked="(checked) => handleCheck(index, checked)"
                  @detail="(item) => openProdInfoPop(item)"
                  @ordertemp="(item) => orderNow(item, 'alone')"
                  @item="(item) => updateItem(item)"
                />
              </template>
            </div>
            <!-- // D: MO 전용 -->
          </section>
          <section
            class="basket-list-box"
            v-if="initData.list.soldOutBasketListCount > 0"
          >
            <div class="line-title-box c-title-level3">
              <strong>판매종료제품 : </strong>
              <b>{{ initData.list.soldOutBasketListCount }}개</b>
            </div>
            <div class="c-order-control-box">
              <div class="left-box">
                <div class="c-checkbox type-small">
                  <input
                    type="checkbox"
                    id="all-chk2"
                    name="chkgroup2"
                    v-model="soldOutAllChecked"
                  />
                  <label for="all-chk2">전체선택</label>
                </div>
                <button
                  type="button"
                  class="btn-selected-delete"
                  @click="deleteSoldOutCheckedItems()"
                >
                  <i class="c-icon icon-check"></i>
                  <span>선택삭제</span>
                </button>
              </div>
            </div>
            <!-- D: PC 전용 -->
            <div class="scroll-x">
              <div class="scroll-x-inner">
                <div class="table-box only-pc" style="width: 1102px">
                  <div class="c-table">
                    <table>
                      <caption>
                        장바구니 판매종료제품 리스트 테이블
                      </caption>
                      <colgroup>
                        <col style="width: 380px" />
                        <col />
                        <col />
                        <col />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">제품</th>
                          <th scope="col">용량</th>
                          <th scope="col">수량</th>
                          <th scope="col">금액</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="soldOutcheckedItems.length > 0">
                          <BasketSoldOutRow
                            v-for="(item, index) in initData.list
                              .soldOutBasketList"
                            :key="item.cartSn"
                            :index="index"
                            :item="item"
                            :checked="soldOutcheckedItems[index]?.checked"
                            @checked="
                              (checked) => handleSoldOutCheck(index, checked)
                            "
                          />
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-products only-mo">
              <template v-if="soldOutcheckedItems.length > 0">
                <MoBasketSoldOutRow
                  v-for="(item, index) in initData.list.soldOutBasketList"
                  :key="item.cartSn"
                  :index="index"
                  :item="item"
                  :checked="soldOutcheckedItems[index]?.checked"
                  @checked="(checked) => handleSoldOutCheck(index, checked)"
                />
              </template>
            </div>
            <!-- // D: MO 전용 -->
          </section>

          <!-- D: MO 전용 -->
          <div class="c-btn-area type-full is-fixed" data-bottom-fixed>
            <button
              type="button"
              class="c-button type-small type-primary"
              @click="orderNow(null, 'checked')"
            >
              <span
                >주문하기 ({{ totalCount }}개
                {{ Number(totalPrice).toLocaleString() }}원)</span
              >
            </button>
          </div>
          <!-- // D: MO 전용 -->
        </div>

        <!-- D: 장바구니(제품無) 페이지 -->
        <div
          v-if="
            initData.page.hasNodata &&
            initData.list.orderableBasketListCount == 0 &&
            initData.list.soldOutBasketListCount == 0
          "
          class="c-no-data-box"
        >
          <div class="icon-box">
            <i class="c-icon icon-nodata size-large"></i>
          </div>
          <p class="text">장바구니에 담긴 제품이 없습니다.</p>
        </div>

        <template v-if="initData.list.fashionItemList.length > 0">
          <p class="recommend-title">
            이런 제품은 어떠세요? <br class="only-mo" />
            최근 많이 찾는 제품을 추천드려요.
          </p>
          <div class="c-products col5">
            <BasketFashionItems
              v-for="item in initData.list.fashionItemList"
              :key="item.matnr"
              :item="item"
              @detail="(item) => openProdInfoPop(item)"
              @global-order="(item) => globalOrderNow(item)"
            />
          </div>
        </template>
      </div>
    </div>

    <ProdInfoPop
      v-if="isShowProdInfoPop"
      v-bind="prodInfoPopProps"
      @close="() => (isShowProdInfoPop = false)"
    />

    <QuickMenu />
  </div>
</template>
<script setup name="basket">
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import { useAuthStore } from "@/store";
import { getLocalStorage } from "@/utils/cmUtil";
import {
  computed,
  inject,
  onMounted,
  provide,
  reactive,
  readonly,
  ref,
  watch,
} from "vue";
import { api } from "@/plugins/api";
import router from "@/router";
import BasketOrderableRow from "@/components/paintpro/order/basketOrderableRow.vue";
import BasketSoldOutRow from "@/components/paintpro/order/basketSoldOutRow.vue";
import BasketFashionItems from "@/components/paintpro/order/basketFashionItems.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as store from "@/store";
import * as orderApi from "@/api/orderApi.js";
import { useRoute } from "vue-router";
import MoBasketOrderableRow from "@/components/paintpro/order/moBasketOrderableRow.vue";
import MoBasketSoldOutRow from "@/components/paintpro/order/moBasketSoldOutRow.vue";

const url = inject("url_prefix");
const authStore = useAuthStore();
const route = useRoute();

const initData = reactive({
  page: {
    isLogin: false,
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [{ name: "장바구니", path: "/paintpro/orderBasket" }],
    path: "",
    isPageInit: false,
    hasNodata: false,
  },
  codes: {
    CODE_WERKS: [],
    CODE_GOODS_FILE_SE_CD: [],
  },
  popup: {
    isShowProdInfoPop: false, // 제품상세
  },
  list: {
    orderableBasketListCount: 0, // 주문가능제품 개수
    soldOutBasketListCount: 0, // 판매종료제품 개수
    orderableBasketList: [], // 주문가능제품
    soldOutBasketList: [], // 판매종료제품
    fashionItemList: [], // 인기제품
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

const checkedItems = ref([]); // 체크된 아이템 관리
const soldOutcheckedItems = ref([]); // 판매종료 체크 아이템 관리
const allChecked = computed({
  get: () => {
    if (checkedItems.value.length === 0) {
      return false; // 리스트가 비어있을 때는 전체선택 체크박스를 false로 설정
    }
    return checkedItems.value.every((item) => item.checked);
  }, // 전체선택 체크박스 값
  set: (value) =>
    (checkedItems.value = checkedItems.value.map((item) => ({
      ...item,
      checked: value,
    }))),
}); // 체크박스 전체선택

const soldOutAllChecked = computed({
  get: () => {
    if (soldOutcheckedItems.value.length === 0) {
      return false; // 리스트가 비어있을 때는 전체선택 체크박스를 false로 설정
    }
    return soldOutcheckedItems.value.every((item) => item.checked);
  }, // 전체선택 체크박스 값
  set: (value) =>
    (soldOutcheckedItems.value = soldOutcheckedItems.value.map((item) => ({
      ...item,
      checked: value,
    }))),
}); // 체크박스 전체선택

const noExistChecked = computed(() =>
  checkedItems.value.every((item) => item.checked === false)
);
const noExistSoldOutChecked = computed(() =>
  soldOutcheckedItems.value.every((item) => item.checked === false)
);

const totalPrice = computed(() =>
  checkedItems.value
    .filter((item) => item.checked)
    .reduce((sum, item) => {
      return sum + item.kbetr * item.goodsQty;
    }, 0)
); // 총 가격
const totalCount = computed(
  () => checkedItems.value.filter((item) => item.checked).length
);

const prodInfoPopProps = ref({
  matnr: null,
}); // 제품상세팝업
const isShowProdInfoPop = ref(false);
const selectedBranch = ref(null);

provide("CODE_WERKS", readonly(initData.codes.CODE_WERKS));
provide(
  "CODE_GOODS_FILE_SE_CD",
  readonly(initData.codes.CODE_GOODS_FILE_SE_CD)
);

onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

async function pageInit() {
  await pageInitData();
  searchCmd();
}

async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "WERKS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } });

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message}`);
    return false;
  }

  initData.page.path = route.path;
  initData.page.token = getLocalStorage("token");
  initData.page.isLogin = authStore?.user ? true : false;
  initData.page.userLoginInfo = authStore?.user;
  initData.codes.CODE_WERKS = res.data.cmCode_code1;
  initData.codes.CODE_GOODS_FILE_SE_CD = res.data.cmCode_code2;

  // 영업사원 디폴트
  initData.eventBus.salesPersonIndex =
    store.useEventBusStore()?.salesPersonIndex;
  selectedBranch.value =
    initData.page.userLoginInfo.empList[initData.eventBus.salesPersonIndex];
}

async function searchCmd() {
  getBasketList(); // 장바구니
  getFashionList(); // 인기제품 리스트
  initData.page.isPageInit = true;
}

// 주문하기
async function orderNow(itemParam, flag) {
  const item = itemParam;
  const params = {
    masterData: {},
    detailList: [{}],
  };
  params.masterData.orderTmpStatusCd = 1; // 임시주문상태코드 - 1:주문대기, 2:주문완료
  params.masterData.zempNo = selectedBranch.value?.kunn2; // 직원사번
  params.masterData.dmndScrnPath = initData.page.path; // 임시주문 호출경로

  if (flag == "alone") {
    if (itemParam.zzlqdCls === "A") {
      const res = await orderApi.checkSetProduct(item.goodsSn);
      if (res.set) {
        params.detailList[0].goodsSn = res.goodsSn;
        params.detailList[0].goodsQty = itemParam.goodsQty || 1;
      } else {
        params.detailList[0] = item;
      }
    } else {
      params.detailList[0] = item;
    }
  } else if (flag == "checked") {
    if (noExistChecked.value) {
      await cmUtil.alert("제품을 선택해주세요.");
      return;
    }
    const checkedGoods = checkedItems.value
      .filter((item) => item.checked)
      .map((item) => item.goodsSn);
    params.detailList = initData.list.orderableBasketList
      .filter((item) => checkedGoods.includes(item.goodsSn))
      .map((item) => ({ goodsSn: item.goodsSn, goodsQty: item.goodsQty }));
  } else if (flag == "all") {
    params.detailList = initData.list.orderableBasketList;
  }

  const res = await api.post(`${url}/order/saveOrderTemp`, params);
  if (res.resultCode === 200) {
    const orderTmpSn = res.data;
    router.push({
      path: "/paintpro/orderOrder",
      query: { orderTmpSn: orderTmpSn },
    });
  }
}

// 바로주문(낱개)
async function globalOrderNow(item) {
  const params = {
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    zempNo: selectedBranch.value?.kunn2,
    path: initData.page.path,
  };

  await orderApi.createTempOrder(params);
}

// 장바구니 리스트
async function getBasketList() {
  const res = await api.get(`${url}/basket/getBasketList`);
  initData.list.orderableBasketListCount = res.data.orderableBasketListCount;
  initData.list.soldOutBasketListCount = res.data.soldOutBasketListCount;
  initData.list.orderableBasketList = res.data.orderableBasketList;
  initData.list.soldOutBasketList = res.data.soldOutBasketList;

  // 체스리스트
  checkedItems.value = initData.list.orderableBasketList.map((item) => ({
    orderTmpSn: item.orderTmpSn,
    orderDtlTmpSn: item.orderDtlTmpSn,
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    kbetr: item.kbetr,
    checked: false,
  }));
  // 판매종료 체스리스트
  soldOutcheckedItems.value = initData.list.soldOutBasketList.map((item) => ({
    goodsSn: item.goodsSn,
    checked: false,
  }));

  if (
    initData.list.orderableBasketListCount > 0 ||
    initData.list.soldOutBasketListCount > 0
  ) {
    initData.page.hasNodata = false;
  } else {
    initData.page.hasNodata = true;
  }
}

// 인기제품 리스트
async function getFashionList() {
  const param = {
    fashionRcmdtnSeCd: "F",
    matkl: selectedBranch.value?.matkl,
    vkorg: selectedBranch.value?.vkorg,
  };
  const res = await api.get(`${url}/basket/getFashionList`, { params: param });
  initData.list.fashionItemList = res.data.slice(0, 5);
}

// 상세팝업에서 장바구니 담기
const addCartItem = async (param = { product: null, quantity: 0 }) => {
  const res = await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: initData.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });

  if (res.resultCode === 200) {
    // 정상적으로 등록되었을 경우
    await getBasketList();
  }
};
provide("addCartItem", addCartItem);

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: product.quantity,
    zempNo: selectedBranch.value.kunn2,
    path: initData.page.path,
  };
  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);

// 인기제품에서 장바구니 담기
const addCartItemFromFashion = async (
  param = { product: null, quantity: 1 }
) => {
  const res = await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: initData.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });
  if (res.resultCode === 200) {
    await getBasketList();
  }
};
provide("addCartItemFromFashion", addCartItemFromFashion);

// 선택삭제
async function deleteCheckedItems() {
  if (noExistChecked.value) {
    await cmUtil.alert("제품을 선택해주세요.");
    return;
  }
  if (allChecked.value == true) {
    if (
      !(await cmUtil.confirm(
        "장바구니에 담은<br> 전체 제품을<br>삭제하시겠습니까?"
      ))
    ) {
      return;
    }
  }
  const deleteItemList = checkedItems.value.filter(
    (item) => item.checked === true
  );
  const res = await cmApi.deleteUserBasketProds(deleteItemList);
  deleteItemList.map((item) => item.goodsSn);
  if (res.resultCode === 200) {
    await getBasketList();
    await cmUtil.alert("삭제되었습니다.");
  }
}

// 판매종료 선택삭제
async function deleteSoldOutCheckedItems() {
  if (noExistSoldOutChecked.value) {
    await cmUtil.alert("판매종료제품을 선택해주세요.");
    return;
  }
  if (soldOutAllChecked.value == true) {
    if (
      !(await cmUtil.confirm(
        "장바구니에 담은 전체 판매종료제품을<br>삭제하시겠습니까?"
      ))
    ) {
      return;
    }
  }
  const deleteItemList = soldOutcheckedItems.value.filter(
    (item) => item.checked === true
  );
  const res = await cmApi.deleteUserBasketProds(deleteItemList);
  deleteItemList.map((item) => item.goodsSn);
  if (res.resultCode === 200) {
    await cmUtil.alert("삭제되었습니다.");
    await getBasketList();
  }
}

// 제품 상세 팝업
function openProdInfoPop(item) {
  prodInfoPopProps.value.matnr = item.matnr;
  isShowProdInfoPop.value = true;
}

// 수량 업데이트
function updateItem(item) {
  const matchingItem = checkedItems.value.find(
    (target) => target.goodsSn == item.goodsSn
  );
  matchingItem.goodsQty = item.goodsQty;
}

// ROW 체크박스
function handleCheck(index, checked) {
  checkedItems.value[index].checked = checked;
}

function handleSoldOutCheck(index, checked) {
  soldOutcheckedItems.value[index].checked = checked;
}

// 헤더 영업사원 콤보박스
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (
      newValue >= 0 &&
      initData.page.userLoginInfo?.empList?.length > newValue
    ) {
      selectedBranch.value = initData.page.userLoginInfo.empList[newValue];
      getFashionList();
    }
  }
);
</script>
